export default __webpack_public_path__ + "15832787b0792031870b0da55d7049da.svg";